import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import { GridPopper } from 'src/components/grid-card/grid-popper.component'
import { useRemoveUser2FaStatus, useUpdateUserSuspension } from 'src/hooks'
import { EUserRoles, IProfileUserResponse } from 'src/types'
import { WhiteLabelModal } from './white-label-modal/white-label-modal.component'

interface IUserMoreIconProps {
  user: IProfileUserResponse
}

const UserMoreIcon = ({ user }: IUserMoreIconProps) => {
  const [t] = useTranslation()
  const [open, setOpen] = useState(false)
  const [modalOpen, setModelOpen] = useState(false)
  const { mutateAsync: updateUserSuspension } = useUpdateUserSuspension()
  const { mutate: disable2fa } = useRemoveUser2FaStatus()
  const anchorRef = useRef(null)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleSuspension = async () => {
    await updateUserSuspension({ userId: user.id, suspended: !user.suspended })
  }
  const handleDisable2fa = async () => {
    disable2fa(user.id)
  }

  const handleModalOpen = () => {
    setModelOpen(true)
  }

  const handleModalClose = () => {
    setModelOpen(false)
  }



  const items = [
    {
      title: user.suspended ? t('unsuspend-user-button-text.v') : t('suspend-user-button-text.v'),
      onClick: handleSuspension,
    },
    {
      title: t('disable-2fa-button-text.v'),
      onClick: handleDisable2fa,
      disabled: !user.two_factor_method || user.roles.includes(EUserRoles.superadmin),
    },
    {
      title: t('assign-white-label-button-text.v'),
      onClick: handleModalOpen,
      // disabled: !user.two_factor_method || user.roles.includes(EUserRoles.superadmin),
    },
  ]

  return (
    <>
      <IconButton ref={anchorRef} onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <GridPopper items={items} handleClose={handleClose} open={open} anchorRef={anchorRef} />
      <WhiteLabelModal open={modalOpen} handleClose={handleModalClose} userId={user.id} />
    </>
  )
}

export { UserMoreIcon }
